import { apiSlice } from "../../app/api/apiSlice";

export const usersApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getUsers: builder.query({
      query: (params) => ({
        url: "/api/v1/accounts/users/",
        params,
      }),
      providesTags: ["User"],
    }),
    getUser: builder.query({
        query: (id) => `/api/v1/accounts/users/${id}/`,
        providesTags: (result, error, id) => [{ type: "User", id }],
    }),
    getContractorsList: builder.query({
      query: () => "/api/v1/accounts/contractors/",
    }),
  }),
});

export const { useGetUsersQuery, useGetUserQuery, useGetContractorsListQuery } = usersApiSlice;
